import { render, staticRenderFns } from "./behavior.vue?vue&type=template&id=1a76a686&"
import script from "./behavior.ts?vue&type=script&lang=ts&"
export * from "./behavior.ts?vue&type=script&lang=ts&"
import style0 from "./behavior.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports